import LocalStorage, { StorageKeys } from 'utils/local-storage';

export const preloadedOrder = () => {
  const order = LocalStorage.getItem(StorageKeys.ORDER);
  return order || {};
};
